import React, { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface DiscountProps {
  discountPercent: number;
  discountDefault?: string;
  isShowDiscount: boolean;
  isDiscount50Available: boolean;
  isLoading?: boolean;
  isBonuses?: boolean;
  text: string;
}

const defaultProps = {
  isLoading: false,
  isBonuses: false,
};

const Discount: FC<DiscountProps> = ({
  discountPercent,
  discountDefault,
  isShowDiscount,
  isDiscount50Available,
  isLoading,
  isBonuses,
  text,
}) => {
  return !isLoading ? (
    <div
      className={`payment__content__options__number-of-month-selector__header__discount ${
        isDiscount50Available ? 'discount50' : ''
      } ${isShowDiscount ? 'active' : 'hide'}`}
    >
      {!isBonuses ? (
        <span>{isDiscount50Available ? `${text} ${discountPercent}%` : `${discountDefault}`}</span>
      ) : (
        <span>{`+${discountPercent}% ${text}`}</span>
      )}
    </div>
  ) : (
    <CircularProgress size={31} color="inherit" />
  );
};

Discount.defaultProps = defaultProps;

export default Discount;
